module.exports = __webpack_public_path__ + "static/img/success-center.297f057b.png";